// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style_wrapper__HUPhN {\n  display: flex;\n  gap: 20px;\n}", "",{"version":3,"sources":["webpack://./src/admin/main/promotion/style.module.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;AACJ","sourcesContent":[".wrapper\n    display: flex\n    gap: 20px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "style_wrapper__HUPhN"
};
export default ___CSS_LOADER_EXPORT___;
